import main from '@/store/modules/pages/main';
import process from '@/store/modules/pages/process';

export default {
  namespaced: true,
  modules: {
    main,
    process,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/pages/index.js